import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-showing-list-draggable',
  templateUrl: './showing-list-draggable.component.html',
  styleUrls: ['./showing-list-draggable.component.css']
})
export class ShowingListDraggableComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
